<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div class="vx-navbar-wrapper">
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <v-nav-menu
      :navMenuItems = "navMenuItems"
      title         = "appTitle"
      :appTitle            = "appTitle"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />
       <!-- <top-alert/> -->
    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
      <vs-popup class="holamundo timeout"  title="Warning!" :active.sync="popupConter" >
       <div >
         <h1 style="text-align:center;font-weight: 100%; text-align: center;font-size: 2em;">
           Your session has expired. You will be automatically logged out after <span style="color:red">{{counter}}</span> seconds.</h1>
       </div>
       <div class="mt-5">
        <vs-row vs-w="12">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button  color="success" @click="Relogin()">Keep Logged-in</vs-button>
                <vs-button  class="ml-2" @click="logout()">Logout</vs-button>
        </vs-col>
      </vs-row>
       </div>
    </vs-popup>

    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                <!-- DROPDOWN -->
<!--                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">-->
<!--                  <vs-button radius icon="icon-settings" icon-pack="feather" />-->

<!--                  <vs-dropdown-menu class="w-32">-->
<!--                    <vs-dropdown-item>-->
<!--                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">-->
<!--                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />-->
<!--                        <span>Profile</span>-->
<!--                      </div>-->
<!--                    </vs-dropdown-item>-->
<!--                    <vs-dropdown-item>-->
<!--                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">-->
<!--                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />-->
<!--                        <span>Tasks</span>-->
<!--                      </div>-->
<!--                    </vs-dropdown-item>-->
<!--                    <vs-dropdown-item>-->
<!--                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">-->
<!--                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />-->
<!--                        <span>Inbox</span>-->
<!--                      </div>-->
<!--                    </vs-dropdown-item>-->
<!--                  </vs-dropdown-menu>-->

<!--                </vs-dropdown>-->

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
   </div>
</template>


<script>
import BackToTop from 'vue-backtotop'
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import {ADD_LOGIN_TIME, GET_THEME_SETTING, ME_DATA,ADD_RELOGIN_TIME} from '@/graphql'
import TopAlert from '../components/navbar/components/TopAlert.vue'


export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    TopAlert,
  },
  data () {
    return {

      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      appTitle        :  this.$store.state.themeTitle,
      meID:'',
      countDown : 10,
      popupConter:false,
      startCount:false
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    }
  },
  computed: {
        
    // appTitle () { return this.$store.state.themeTitle },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark () {
      return this.$store.state.theme === 'dark'
    },
    layoutTypeClass () {
      return `main-${this.mainLayoutType}`
    },
    mainLayoutType () {
      return this.$store.state.mainLayoutType
    },
    navbarClasses () {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    themeMode: {
      get () {
        return this.$store.state.theme
      },
      set (val) {
        this.$store.dispatch('updateTheme', val)
      }
    },
    layoutType: {
      get () {
        return this.$store.state.mainLayoutType
      },
      set (val) {
        this.$store.commit('UPDATE_MAIN_LAYOUT_TYPE', val)
      }
    },
    setTitle: {
      get () {
        return this.$store.state.themeTitle
      },
      set (val) {
        this.$store.commit('UPDATE_APP_TITLE', val)
      }
    },
    appLogo: {
      get () {
        return this.$store.state.themeLogo
      },
      set (val) {
        this.$store.dispatch('UpdateAppLogo', val)
      }
    },
    primaryColor: {
      get () {
        return this.$store.state.themePrimaryColor
      },
      set (val) {
        this.$store.commit('UPDATE_PRIMARY_COLOR', val)
      }
    },
    reduced_sidebar: {
      get () {
        return this.$store.state.reduceButton
      },
      set (val) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', val)
      }
    },
    setTopBarTitle: {
      get () {
        return this.$store.state.topBarTitle
      },
      set (val) {
        this.$store.commit('UPDATE_APP_TOP_BAR_TITLE', val)
      }
    },
    showLoginImg:{
      get () {
        return this.$store.state.showLoginImg
      },
      set (val) {
        this.$store.dispatch('updateAppLoginShowImg', val)
      }
    },
    counter(){
      return this.countDown
    }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        // this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    LastLogin () {
      this.countDown=10
      this.$apollo
        .mutate({
          mutation: ADD_LOGIN_TIME,
          variables: {
            id: this.meID
          }
        })
        .then(response => {
          if(response.data.addLoginTime.status==false){
              this.popupConter=true
              this.startCount=true
              this.countDownTimer()
          }
        })
        .catch(error => {
         window.location = '/login'
          console.log(error)
        })
    },
    countDownTimer() {
                if(this.startCount){
                if(this.countDown > 0) {
                    setTimeout(() => {
                        console.log(this.countDown)
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
                else{
                   this.logout()
                }
              }
            },
    Relogin(){
       this.countDown=10
       this.popupConter=false
       this.startCount=false
       this.$apollo
        .mutate({
          mutation: ADD_RELOGIN_TIME,
          variables: {
            id: this.meID
          }
        })
        .then(response => {
          console.log(response)
        })
    },   
    logout () {
      localStorage.removeItem('userRoles')
      localStorage.removeItem(ROLES_KEY)
      localStorage.removeItem('app-token')
      localStorage.removeItem('userId')
      localStorage.setItem('userRoles', JSON.stringify({name: 'guest'}))
      localStorage.removeItem('userImage')
      localStorage.removeItem('userName')
      localStorage.removeItem('userEmailPhone')
      window.location = '/login'
    }    
  },

  beforeCreate () {
    this.$apollo
      .query({
        query: GET_THEME_SETTING
      })
      .then(response => {
        // console.log(response)
        if (response.data.getThemeSetting.app_logo !== null) {
          this.appLogo = response.data.getThemeSetting.app_logo

        }
        if (response.data.getThemeSetting.set_title !== null) {
          this.setTitle = response.data.getThemeSetting.set_title

        }
        if (response.data.getThemeSetting.theme_mode !== null) {
          this.themeMode = response.data.getThemeSetting.theme_mode

        }
        if (response.data.getThemeSetting.change_layout !== null) {
          this.layoutType = response.data.getThemeSetting.change_layout

        }
        if (response.data.getThemeSetting.theme_color !== null) {
          this.primaryColor = response.data.getThemeSetting.theme_color
          this.$vs.theme({primary:  response.data.getThemeSetting.theme_color})

        }
        if (response.data.getThemeSetting.collapse_sidebar !== null) {
          this.reduced_sidebar = response.data.getThemeSetting.collapse_sidebar

        }
        if (response.data.getThemeSetting.top_bar_title !== null) {
          this.setTopBarTitle = response.data.getThemeSetting.top_bar_title
        }
        if (response.data.getThemeSetting.show_login_img !== null) {
          this.showLoginImg = response.data.getThemeSetting.show_login_img
        }

      })
      .catch(error => {
        console.log(error)
      })

  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    this.meID=localStorage.getItem('userId');

    // this.$apollo
    //   .query({
    //     query: ME_DATA
    //   })
    //   .then((response) => {
    //     this.meID = response.data.me.id
    //   })
    //   .catch((error) => {
    //     // window.location = '/login'
    //   })
      
    this.interval = setInterval(() => this.LastLogin(), 60000)

var userRoles = JSON.parse(localStorage.getItem('userRoles'))
userRoles = userRoles[0].name
if(userRoles==='user'){
   this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", process.env.VUE_APP_MAIN_MENU_TYPE_FOR_USER);
}
}
  
  
}

</script>
<style>
.timeout .vs-popup{
      width: 500px !important;
}
.timeout .vs-popup--title{
    background: #7367F0 !important;
}
.timeout .vs-popup--title h3{
    color: #ffffff !important;
}
.timeout .vs-popup--close{
  display: none;
}
</style>